import { render, staticRenderFns } from "./ptTableRowParlay.vue?vue&type=template&id=ef80ae4c&lang=pug&"
import script from "./ptTableRowParlay.vue?vue&type=script&lang=js&"
export * from "./ptTableRowParlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports